

















import Vue from 'vue'
import Template from '@/types/Template.interface'
export default Vue.extend({
    data() {
        return {
            selectedTemplate: null
        }
    },
    mounted() {
        //  Set our selected template to the default template
        this.selectedTemplate = this.$store.getters.defaultTemplate
    },
    computed: {
        invoiceTemplates(): Template[] {
            //  If no templates, return empty array
            if (!this.messageTemplates) return []

            //  Else, filter out our templates
            return this.messageTemplates.filter(
                (template: Template) => template.type == 'invoice'
            )
        },
        messageTemplates(): Template {
            return this.$store.getters.messageTemplates
        }
    },
    methods: {
        templatesInvoiceSelected(template: Template): void {
            //  Check if the template body contains an invoice link
            const hasLink = template.message_body.includes('{{ InvoicePayLink }}')

            //  If the template does NOT have an invoice link, concatenate the link
            if (!hasLink) template.message_body += ' {{ InvoicePayLink }}'

            //  Forward the selected template to the MessagePreview
            this.$emit('templateSelected', template)
        }
    }
})
